import AssetService from '@/services/AssetService';

export const PopupPrizes = ({ onClose = () => {} }) => {
  const setPopup = useAppStore((state) => state.setPopup);

  const _onClose = useCallback(() => {
    setPopup(null);
    onClose();
    AssetService.getAsset('s_button').play();
  }, [onClose]);

  const { t } = useTranslation();
  const items = [
    t('tutorial.items.0'),
    t('tutorial.items.1'),
    t('tutorial.items.2'),
  ];

  return (
    <Popup
      popupId="prizes"
      className="frame-brown font-gellix text-[1.8rem] leading-[1.18] font-semibold tracking-[0.02em] text-black"
      onClose={_onClose}
    >
      <img
        src="/assets/images/jeremy-512.gif"
        className="w-[12rem]"
      />
      <h2 className="typo-h2 mt-2">{t('tutorial.heading')}</h2>

      <div>
        <div className="mt-3">{t('tutorial.subheading')}</div>
        <ol className="mt-1 mb-3 flex w-fit list-decimal flex-col gap-1 pl-[2.2rem] leading-[1.2] text-balance whitespace-pre-line">
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ol>
      </div>

      <button
        className={cn(
          'btn-primary',
          'w-[100%] text-[1.5rem] tracking-[-0.019em]'
        )}
        onClick={_onClose}
      >
        {t('tutorial.cta')}
        <img
          src="/assets/images-next/arrow-right.webp"
          className="ml-1 h-[1.5rem] text-[1.5rem] leading-none"
        />
      </button>
    </Popup>
  );
};
